import permit from './permit';
import vehicles from './vehicles';

export default {
  namespaced: true,
  modules: {
    permit,
    vehicles,
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/permits/index.js